module.exports = __webpack_public_path__ + "img/error-shutdown.b0917550.png";